import { CircularProgress, Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGetPurchaseCategoryDesign } from "../API/api";
import Product from "features/clients/Purchase/Category/ProductPage/Product";
import { transformDataForTrayModal } from "utils/transformdata";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import GoToTop from "components/ui/GoToTop";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { ProductCard } from "components/ui";
import { useParams } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useLocation } from "react-router-dom";
function CategoryDesignPurchasePage({ category, subCategory }) {
  
  const location = useLocation(); 
  const clientFlow = location.pathname.includes("client-flow");

  const { ref, inView } = useInView();
  const [categoryProductData, setCategoryProductData] = useState([]);
  const { clientId } = useParams();
  const { setSortOptions } = useContext(SortContext);
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchResultCount, setSearchSuffix, dynamicfilterCount, filterChangeCount, filterChangeDesignCount } =
    useGlobalContext();
  //API
  const { data, isLoading, error, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetPurchaseCategoryDesign({
    clientCode: clientId,
    categoryName: category,
    subCategoryName: subCategory,
    limit: 20,
  });

  useEffect(() => {
    if (data) {
      const allData = data?.pages?.flatMap((page) => page?.data || []);
      setCategoryProductData(allData);
    }
  }, [data]);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalDesignCount);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
    }

    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [categoryProductData]);

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  if (isLoading) {
    return <ProductSkeleton count={20} />;
  }

  if (error) {
    return <p>Error</p>;
  }
  return (
    <>
      <InfiniteScroll
        dataLength={categoryProductData.length || 0}
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        loader={isFetchingNextPage && <ProductSkeleton count={20} />}
        scrollThreshold={0.8}
        scrollableTarget="purchase-scroll-container"
      >
        <Grid
          id="purchase-scroll-container"
          container
          direction="row"
          justifyContent="flex-start"
          sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px", maxHeight: "calc(100vh - 145px)", overflow: "auto", scrollbarWidth: "none"}}
          className="Grid-padding"
          rowGap={"16px"}
        >
          {categoryProductData?.length > 0 &&
            categoryProductData?.map((product, ind) => {
              return (
                <Grid item className={`product ${clientFlow ? "client-flow" : ""}`} key={product._id}>
                  <ProductCard data={transformDataForTrayModal(product)} style={clientFlow ? { maxWidth: "442px", minWidth: "390px", height: "244px"} : { width: "474px", height: "254px" }} allData={categoryProductData} />
                </Grid>
              );
            })}
        </Grid>
      </InfiniteScroll>

      <GoToTop />

      {categoryProductData?.length === 0 && (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            margin: "auto",
            padding: "auto",
            justifyContent: "center",
            alignItems: "center",
            height: "78vh",
          }}
        >
          <Background />
        </div>
      )}
    </>
  );
}

export default CategoryDesignPurchasePage;
